export default __webpack_public_path__ + "static/hubspot-611282d259bc5b5d139247fa74f49b74.png";